import { PageContainer, PageContentView } from 'components/shared';

import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useParams, useStateManager } from "@bcm-dev/bcms-vite";
import Classes, { ParticipantImportTemplate } from "model";
import React from 'react';
import ImportParticipantsCSVFileWidget from './components/ImportParticipantsCSVFileWidget';
import ImportParticipantsNACHAFileWidget from './components/ImportParticipantsNACHAFileWidget';
import ParticipantImportTemplatesWidget from './components/ParticipantImportTemplatesWidget';
import "./styles.css";
import "./mobile.css";


/**
 * @function ImportACHPage
 * @return {React.Component}
 * @exported true
 * @description The page for imported ACH
 */

export default function ImportACHPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const { widgetID } = useParams();
  const className = props.className?(" "+props.className):"";
  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(widgetID), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
    updateImportTemplates: value =>{
      BCMSStateManagerCRUD.init(state)
      .update(["data", "participantImportTemplatesWidgetData", "template"], ParticipantImportTemplate.init({}))
      .update(["data", "participantImportTemplatesWidgetData", "importTemplates"], value)
      .update(["data", "importParticipantsCSVFileWidgetData", "importTemplates"], value)

      .submit(setState);
    }
  });

  return (
    <PageContainer className={"import-ach-page"+className} state={{ data, ui }} controller={controller}>
      <PageContent />
    </PageContainer>
  );
}

// No data changes for now.
export const getDefaultData = () => ({
  participantImportTemplatesWidgetData: {
    template: ParticipantImportTemplate.init({}),
    importTemplates: ParticipantImportTemplate.initAll(),
  },
  importParticipantsCSVFileWidgetData: {
    selectedTemplate: "select",
    fileName:"Payroll.csv",
    importTemplates: ParticipantImportTemplate.initAll(),
  },
  importParticipantsNACHAFileWidgetData: {
    fileName:"Payroll_NACHA.csv",
  }
});

// Few ui changes for now.
export const getDefaultUI = showOnlyWidgetID => {
  const _showOnlyWidgetID = showOnlyWidgetID ?? "";
  let showParticipantImportTemplatesWidget = true;
  let showImportParticipantsCSVFileWidget = true;
  let showImportParticipantsNACHAFileWidget = true;

  // If a specific widget id has been passed through the params,
  // show only that widget on the page.
  if(_showOnlyWidgetID !== "") {
    switch(_showOnlyWidgetID) {
      case "participantImportTemplates":
        showParticipantImportTemplatesWidget = true;
        showImportParticipantsCSVFileWidget = false;
        showImportParticipantsNACHAFileWidget = false;
        break;
      case "importParticipantsCSVFile":
        showParticipantImportTemplatesWidget = false;
        showImportParticipantsCSVFileWidget = true;
        showImportParticipantsNACHAFileWidget = false;
        break;
      case "importParticipantsNACHAFile":
        showParticipantImportTemplatesWidget = false;
        showImportParticipantsCSVFileWidget = false;
        showImportParticipantsNACHAFileWidget = true;
        break;
      default:
        break;
    }
  }

  return {
  showParticipantImportTemplatesWidget: { show: showParticipantImportTemplatesWidget },
  showImportParticipantsCSVFileWidget: { show: showImportParticipantsCSVFileWidget },
  showImportParticipantsNACHAFileWidget: { show: showImportParticipantsNACHAFileWidget },

  participantImportTemplatesWidgetUI: {
    showAddTemplateFormView: false,
    showMatchCriteria: true
  },
  importParticipantsCSVFileWidgetUI: {
    isFileChosen: false,
    isFileUploaded: false,
    showFileUploadedBanner: false,
    participantImportTemplateSelect: { isActive: false }
  },
  importParticipantsNACHAFileWidgetUI: {
    isFileChosen: false,
    isFileUploaded: false,
    showFileUploadedBanner: false
  }
}
};

function PageContent(props) {
  const { data, ui, updateImportTemplates} = useStateManager();
  const actions = {
    updateImportTemplates
  }

  return (
    <PageContentView>
      <div className="flex-container flex-vertical flex-width">
        { ui.showParticipantImportTemplatesWidget.show && 
        <ParticipantImportTemplatesWidget data={data.participantImportTemplatesWidgetData}
          ui={ui.participantImportTemplatesWidgetUI} actions={actions}/>
        }
        { ui.showImportParticipantsCSVFileWidget.show && 
        <ImportParticipantsCSVFileWidget data={data.importParticipantsCSVFileWidgetData}
          ui={ui.importParticipantsCSVFileWidgetUI} actions={actions}/>
        }
        { ui.showImportParticipantsNACHAFileWidget.show && 
        <ImportParticipantsNACHAFileWidget data={data.importParticipantsNACHAFileWidgetData}
          ui={ui.importParticipantsNACHAFileWidgetUI} />
        }
      </div>
    </PageContentView>
  );
}